export const ErrorMessages = {
    REFRESH_TABLETS: {
        title: 'Warning!',
        message:
            'This will trigger a fresh data fetch for all tablets. Are you sure you want to continue?',
    },
    NO_DATA: {
        title: 'Error!',
        message: 'No data available',
    },
    SERVER_ERROR: {
        title: 'Oops!',
        message:
            'Some communication error has occured. Please try again later.',
    },
    UNAUTHORISED_ERROR: {
        title: 'Oops!',
        message: 'You must be logged in to view this page!',
    },
    SERVICE_TEMPORARILY_UNAVAILABLE: {
        title: 'Oops!',
        message:
            'This service is temporarily unavailable. Please try again later!',
    },
    TOKEN_EXPIRED: {
        title: 'Oops!',
        message: 'This session is not valid. Please login to continue.',
    },
    NAME_EXISTS: 'The name already exists',
};
